'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var Reflux = require('reflux');

var _require = require('react-dnd');

var DragDropMixin = _require.DragDropMixin;

/* Actions */
var ProjectActions = require('actions/project');
var ModuleActions = require('actions/module');
var ModuleConnectionActions = require('actions/module-connection');
var DatasourceActions = require('actions/datasource');

/* Stores */
var ProjectStore = require('stores/project');
var ModuleStore = require('stores/module');
var ModuleConnectionStore = require('stores/module-connection');
var LanguageStore = require('stores/language');

/* Components */
var Module = require('./playground/module');
var Connections = require('./playground/connections');

var ProjectPlayground = React.createClass({
  displayName: 'ProjectPlayground',

  mixins: [DragDropMixin, Reflux.connect(ModuleStore, 'modules'), Reflux.connect(ModuleConnectionStore, 'connections')],

  statics: {
    configureDragDrop: function configureDragDrop(registerType) {
      registerType('module_type_item', {
        dropTarget: {
          acceptDrop: function acceptDrop(component, item, evt) {
            var clientX = evt.clientX;
            var clientY = evt.clientY;

            component._onModuleTypeDropped(item.id, { x: clientX, y: clientY });
          }
        }
      });
    }
  },

  componentDidMount: function componentDidMount() {
    // We need datasources to be loaded as modules can show a list of then
    DatasourceActions.loadAll();

    ModuleActions.loadModulesForProject(this.props.id);
    ModuleConnectionActions.loadModuleConnectionsForProject(this.props.id);

    // Listen for keyboard events
    // Has to keydown event as we need to prevent default
    this._bindKeyEvents();
  },

  componentWillUnmount: function componentWillUnmount() {
    ModuleActions.deselectAllModules();
    this._unbindKeyEvents();
  },

  render: function render() {
    var component = this;

    var position = component.props.position;

    var moduleNodes = component.state.modules.map(function (module) {
      return React.createElement(Module, _extends({
        key: module.id
      }, module, {
        onStartDragging: component._onModuleStartDragging,
        onSelect: component._onModuleSelect,
        onStartOutput: component._onModuleStartDraggingOutput.bind(null, module.id),
        onStopInput: component._onModuleStopDraggingInput.bind(null, module.id),
        onTouchEnd: component._onModuleTouchEnd,
        onTouchStartDragging: component._onModuleTouchStartDragging }));
    });

    var transformStyle = 'translate3d(' + position.x + 'px,' + position.y + 'px,0px)';
    var containerStyles = {
      'transform': transformStyle,
      WebkitTransform: transformStyle,
      MozTransform: transformStyle
    };

    var playgroundStyles = {};
    playgroundStyles.backgroundPosition = position.x + 'px ' + position.y + 'px';

    return React.createElement(
      'div',
      _extends({}, component.dropTargetFor('module_type_item'), { className: 'project-playground-wrapper' }),
      React.createElement(
        'div',
        {
          className: 'project-playground-component',
          style: playgroundStyles,
          onMouseMove: component._onMouseMove,
          onMouseDown: component._onMouseDown,
          onMouseUp: component._onMouseUp,
          onTouchStart: component._onTouchStart,
          onTouchEnd: component._onTouchEnd,
          onTouchMove: component._onTouchMove },
        React.createElement(Connections, { connections: component.state.connections, onClick: component._onConnectionClick }),
        React.createElement(
          'div',
          { className: 'module-container', style: containerStyles },
          moduleNodes
        )
      )
    );
  },

  _onModuleTypeDropped: function _onModuleTypeDropped(moduleTypeId, initialPosition) {
    var component = this;

    var _component$props = component.props;
    var id = _component$props.id;
    var position = _component$props.position;

    var offsetPosition = {
      x: initialPosition.x - position.x - 105,
      y: initialPosition.y - position.y - 20
    };

    ProjectActions.addModule(id, moduleTypeId, offsetPosition);
  },

  _onModuleTouchStartDragging: function _onModuleTouchStartDragging(moduleId, evt) {
    this._onModuleStartDragging(moduleId, evt.touches[0]);
  },

  _onModuleStartDragging: function _onModuleStartDragging(moduleId, evt) {
    ModuleActions.startDragging(moduleId, evt.clientX, evt.clientY);
  },

  _onTouchStart: function _onTouchStart(evt) {
    evt.preventDefault();

    console.log('playground', 'onTouchStart');

    this._onMouseDown(evt.touches[0]);
  },

  _onMouseDown: function _onMouseDown(evt) {
    var isPlaygroundTarget = evt.target.className === 'project-playground-component' || evt.target.className === 'module-container' || evt.target.className === 'module-connections-component' || evt.target.tagName.toUpperCase() === 'SVG';
    if (isPlaygroundTarget) {
      ProjectActions.startDragging(this.props.id, evt.clientX, evt.clientY);
    }
  },

  _onTouchMove: function _onTouchMove(evt) {
    evt.preventDefault();

    console.log('playground', 'onTouchMove');

    this._onMouseMove(evt.touches[0]);
  },

  _onMouseMove: function _onMouseMove(evt) {
    if (ModuleConnectionStore.dragging) {
      ModuleConnectionActions.updateDrag(evt.clientX, evt.clientY);
    }

    if (ModuleStore.dragging) {
      ModuleActions.updateDrag(evt.clientX, evt.clientY);
    }

    if (ProjectStore.dragging) {
      ProjectActions.updateDrag(evt.clientX, evt.clientY);
    }
  },

  _onModuleTouchEnd: function _onModuleTouchEnd(evt) {
    this._onTouchUp(evt);
  },

  _onTouchUp: function _onTouchUp(evt) {
    evt.preventDefault();

    console.log('playground', 'onTouchUp');

    this._onMouseUp(evt.touches[0]);
  },

  _onMouseUp: function _onMouseUp() {
    var component = this;

    /* Stop dragging */
    if (ModuleConnectionStore.dragging) {
      ModuleConnectionActions.stopDragging();
    }

    if (ModuleStore.dragging) {
      ModuleActions.stopDragging();
    }

    if (ProjectStore.dragging) {
      ProjectActions.stopDragging();
    }
  },

  _onModuleSelect: function _onModuleSelect(moduleId, modifiers) {
    ModuleActions.selectModule(moduleId, modifiers);
  },

  _onModuleStartDraggingOutput: function _onModuleStartDraggingOutput(moduleId, outputKey) {
    ModuleConnectionActions.startConnectionAtOutput(this.props.id, moduleId, outputKey);
  },

  _onModuleStopDraggingInput: function _onModuleStopDraggingInput(moduleId, inputKey) {
    ModuleConnectionActions.stopConnectionAtInput(this.props.id, moduleId, inputKey);
  },

  _onConnectionClick: function _onConnectionClick(connectionId, modifiers) {
    ModuleConnectionActions.selectConnection(connectionId, modifiers);
  },

  _bindKeyEvents: function _bindKeyEvents() {
    window.addEventListener('keydown', this._onKeyDown);
  },

  _unbindKeyEvents: function _unbindKeyEvents() {
    window.removeEventListener('keydown', this._onKeyDown);
  },

  _onKeyDown: function _onKeyDown(evt) {
    var component = this;

    var doPrevent = false;
    if (evt.keyCode === 8 || evt.keyCode === 46) {
      var d = evt.srcElement || evt.target;
      if (d && (d.tagName.toUpperCase() === 'INPUT' && (d.type.toUpperCase() === 'TEXT' || d.type.toUpperCase() === 'PASSWORD' || d.type.toUpperCase() === 'FILE' || d.type.toUpperCase() === 'EMAIL' || d.type.toUpperCase() === 'SEARCH' || d.type.toUpperCase() === 'DATE' || d.type.toUpperCase() === 'NUMBER') || d.tagName.toUpperCase() === 'TEXTAREA') || d.contentEditable === "true") {
        doPrevent = d.readOnly || d.disabled;
      } else {
        doPrevent = true;
      }
    }

    if (doPrevent) {
      evt.preventDefault();

      var hasSelectedModules = component.state.modules.some(function (module) {
        return module.selected;
      });
      var hasSelectedConnections = component.state.connections.some(function (connection) {
        return connection.selected;
      });

      if (hasSelectedModules && confirm(LanguageStore.translate('project_details_delete_modules_confirmation'))) {
        ModuleActions.deleteSelectedModules();
      }

      if (hasSelectedConnections && confirm(LanguageStore.translate('project_details_delete_connections_confirmation'))) {
        ModuleConnectionActions.deleteSelectedConnections();
      }
    }
  }
});

module.exports = ProjectPlayground;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/playground.js
 **/